export default __webpack_public_path__ + "assets/86f1431124553483cf3ac38345962570.png";